module.exports = __webpack_public_path__ + "static/media/anniu@2x.32a24f5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/active20/anniu@2x.png
// module id = 810
// module chunks = 0